/**
 * Diagnosis
 * 広告運用診断 Yes/Noチャート（導入フロー §A）の対話式制御。
 * PCは静的フローチャート（CSSで全件表示／Yes・Noは pointer-events:none）のため、実質SP専用。
 *
 * 各項目（.p-diagnosis-item）：
 *   - Yes → その項目の解決カードを表示（.is-answered）。＝ここで確定なので、以降（下）の設問・解決は閉じる。
 *   - No  → 次の項目（課題）を表示（.is-open）し、自身の解決は閉じる。
 *   いつでも切替可能（Noで進んだ後に手前へ戻ってYesを押す等）。
 *
 * HTML: <div class="js-diagnosis"> 内に .p-diagnosis-item（.js-diagnosis-yes / .js-diagnosis-no を含む）
 */
export default class Diagnosis {
  constructor(options = {}) {
    this.options = {
      root: '.js-diagnosis',
      item: '.p-diagnosis-item',
      yes: '.js-diagnosis-yes',
      no: '.js-diagnosis-no',
      openClass: 'is-open',
      answeredClass: 'is-answered',
      ...options,
    };

    this.roots = document.querySelectorAll(this.options.root);
    if (this.roots.length > 0) {
      this.init();
    }
  }

  init() {
    this.roots.forEach((root) => {
      const items = Array.from(root.querySelectorAll(this.options.item));
      items.forEach((item, index) => {
        const yes = item.querySelector(this.options.yes);
        const no = item.querySelector(this.options.no);

        if (yes) {
          yes.addEventListener('click', () => this.answer(items, index));
        }
        if (no) {
          no.addEventListener('click', () => this.next(items, index, item, yes));
        }
      });
    });
  }

  // Yes：解決カードを表示し、以降（下）の設問・解決は閉じる（この設問で確定）
  answer(items, index) {
    const item = items[index];
    item.classList.add(this.options.answeredClass);
    const yes = item.querySelector(this.options.yes);
    const no = item.querySelector(this.options.no);
    if (yes) yes.setAttribute('aria-expanded', 'true');
    if (no) no.setAttribute('aria-expanded', 'false');

    // この設問より下の設問は閉じる（開いていた次の課題・解決を消す）
    for (let i = index + 1; i < items.length; i += 1) {
      items[i].classList.remove(this.options.openClass, this.options.answeredClass);
      const nextYes = items[i].querySelector(this.options.yes);
      const nextNo = items[i].querySelector(this.options.no);
      if (nextYes) nextYes.setAttribute('aria-expanded', 'false');
      if (nextNo) nextNo.setAttribute('aria-expanded', 'false');
    }
  }

  // No：自身の解決を閉じ、次の項目（課題）を表示
  next(items, index, item, yes) {
    item.classList.remove(this.options.answeredClass);
    if (yes) yes.setAttribute('aria-expanded', 'false');

    const nextItem = items[index + 1];
    if (nextItem) {
      nextItem.classList.add(this.options.openClass);
    }
  }
}
